import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './messages';

Vue.use(VueI18n);
const languageCode = window.navigator.userLanguage || window.navigator.language;

const i18n = new VueI18n({
  locale: languageCode.startsWith('sk') ? 'sk' : 'cs',
  messages,
});

export default i18n;
